var map = {
	"./back-arrow.svg": "8eb1",
	"./cakeshops.svg": "2f46",
	"./delete.svg": "59a1",
	"./eye.svg": "4df5",
	"./giftcard.svg": "e604",
	"./inactive-eye.svg": "46fb",
	"./location.svg": "1c50",
	"./no-address-icon.svg": "8b62",
	"./orders.svg": "ee96",
	"./phone.svg": "dd82",
	"./reset.svg": "9b4b",
	"./scope-limit.svg": "ef32",
	"./start.svg": "2743",
	"./use-with-favorite.svg": "3fa6",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";